import { jsxs as i, jsx as a } from "react/jsx-runtime";
import t from "classnames";
import { f as c } from "../../styled-qu50FBLM.mjs";
import { Svg as d, Rectangle as f, Path as l, GElement as o } from "./Elements.js";
const s = ({
  className: h = "",
  viewBox: m = "0 0 67 41",
  $cssHelper: r = c,
  focusable: e
}) => /* @__PURE__ */ i(
  d,
  {
    className: t({ [h]: !!h }),
    viewBox: m,
    $cssHelper: r,
    focusable: !!e,
    "aria-hidden": !e,
    children: [
      /* @__PURE__ */ a(f, { fill: "#e8e9e9", height: "41", rx: "4", width: "67" }),
      /* @__PURE__ */ a(
        l,
        {
          d: "M15.48 15.18l-.23-.06H15a5.77 5.77 0 0 0-1-.12h-2.9a.46.46 0 0 0-.2.05.48.48 0 0 0-.26.35l-.62 4v.12a.54.54 0 0 1 .53-.46h1.09c2.16 0 3.85-.88 4.34-3.43a2.07 2.07 0 0 0 0-.22 2.2 2.2 0 0 0-.41-.18h-.11",
          fill: "#212952"
        }
      ),
      /* @__PURE__ */ i(o, { fill: "#24366e", children: [
        /* @__PURE__ */ a(l, { d: "M10.94 15.16a.46.46 0 0 1 .27-.36.46.46 0 0 1 .2-.05h3a6.15 6.15 0 0 1 1 .07h.25l.24.06.1.12a3.17 3.17 0 0 1 .41.17 2.44 2.44 0 0 0-.52-2.21A3.81 3.81 0 0 0 13 12H9.15a.55.55 0 0 0-.54.46L7 22.62a.33.33 0 0 0 .33.38H9.7zm15.53-.66h-2.9a.41.41 0 0 0-.4.34L22 22.22a.24.24 0 0 0 .24.28h1.38a.4.4 0 0 0 .4-.34l.32-2a.41.41 0 0 1 .4-.34h.91A3 3 0 0 0 29 17.09a2.17 2.17 0 0 0-.37-1.85 2.66 2.66 0 0 0-2.16-.74zm.33 2.7c-.15 1-.95 1-1.72 1h-.43l.35-1.9a.24.24 0 0 1 .24-.2h.2c.52 0 1 0 1.27.29a.94.94 0 0 1 .09.81zm8.45-.08h-1.43a.23.23 0 0 0-.24.18l-.06.34-.1-.12a2.22 2.22 0 0 0-1.69-.52 3.16 3.16 0 0 0-3.19 2.48 2.12 2.12 0 0 0 .53 1.89 2.41 2.41 0 0 0 1.8.63 2.93 2.93 0 0 0 2-.71l-.07.35a.24.24 0 0 0 .25.25h1.29a.41.41 0 0 0 .41-.31l.77-4.22a.23.23 0 0 0-.27-.24zm-2 2.4a1.54 1.54 0 0 1-1.61 1.17 1.32 1.32 0 0 1-1-.33.94.94 0 0 1-.22-.87 1.55 1.55 0 0 1 1.6-1.18 1.31 1.31 0 0 1 1 .33 1 1 0 0 1 .24.88z" }),
        /* @__PURE__ */ a(l, { d: "M41.77 17h-1.36a.4.4 0 0 0-.32.18l-1.86 2.93-.79-2.81a.39.39 0 0 0-.38-.3h-1.33a.25.25 0 0 0-.22.33L37 22l-1.4 2.11a.25.25 0 0 0 .19.39h1.35a.38.38 0 0 0 .32-.18L42 17.39a.25.25 0 0 0-.19-.39" })
      ] }),
      /* @__PURE__ */ a(
        l,
        {
          d: "M46.47 14.5h-2.9a.41.41 0 0 0-.4.34L42 22.22a.24.24 0 0 0 .24.28h1.49a.29.29 0 0 0 .28-.24l.33-2.09a.41.41 0 0 1 .4-.34h.91A3 3 0 0 0 49 17.09a2.17 2.17 0 0 0-.37-1.85 2.66 2.66 0 0 0-2.16-.74zm.33 2.7c-.15 1-.95 1-1.72 1h-.43l.35-1.9a.24.24 0 0 1 .24-.2h.2c.52 0 1 0 1.27.29a.94.94 0 0 1 .09.81zm8.45-.08h-1.43a.23.23 0 0 0-.24.18l-.06.34-.1-.12a2.22 2.22 0 0 0-1.69-.52 3.16 3.16 0 0 0-3.19 2.48 2.12 2.12 0 0 0 .53 1.89 2.41 2.41 0 0 0 1.8.63 2.93 2.93 0 0 0 2-.71l-.07.35a.24.24 0 0 0 .25.25h1.29a.41.41 0 0 0 .41-.31l.77-4.22a.23.23 0 0 0-.27-.24zm-2 2.4a1.54 1.54 0 0 1-1.61 1.17 1.3 1.3 0 0 1-1-.33.94.94 0 0 1-.22-.87 1.54 1.54 0 0 1 1.6-1.18 1.31 1.31 0 0 1 1 .33 1 1 0 0 1 .24.88zm3.44-4.32l-1.19 7.52a.24.24 0 0 0 .24.28h1.19a.4.4 0 0 0 .4-.34l1.17-7.38a.24.24 0 0 0-.24-.28h-1.33a.25.25 0 0 0-.24.2",
          fill: "#0092c7"
        }
      ),
      /* @__PURE__ */ a(
        l,
        {
          d: "M10.14 24l.22-1.36H7.5l1.65-10a.12.12 0 0 1 0-.08h4.09a3.62 3.62 0 0 1 2.72.79 1.81 1.81 0 0 1 .44.78 2.78 2.78 0 0 1 0 1.08v.31l.23.12a1.64 1.64 0 0 1 .45.33 1.53 1.53 0 0 1 .37.8 3.28 3.28 0 0 1 0 1.15 4.24 4.24 0 0 1-.49 1.3 2.74 2.74 0 0 1-.78.81 3.13 3.13 0 0 1-1 .46 5.69 5.69 0 0 1-1.3.14h-.32a.94.94 0 0 0-.6.22.92.92 0 0 0-.32.54v.12l-.4 2.4v.08a.16.16 0 0 1 0 .06h-2",
          fill: "#24366e"
        }
      ),
      /* @__PURE__ */ a(
        l,
        {
          d: "M16.46 15v.23c-.51 2.68-2.26 3.61-4.49 3.61h-1.18a.55.55 0 0 0-.54.48l-.75 4.84a.3.3 0 0 0 .29.34h2a.49.49 0 0 0 .48-.42v-.1l.38-2.46v-.14a.48.48 0 0 1 .47-.42h.31a3.56 3.56 0 0 0 3.92-3.15 2.75 2.75 0 0 0-.4-2.38 2.14 2.14 0 0 0-.55-.43",
          fill: "#0092c7"
        }
      )
    ]
  }
);
export {
  s as default
};
